/**
 * Component Registry for Aspen Creek
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-preferred/registry';
import { Header } from './components/Header';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Aspen Creek overrides the parent Header to render a larger logo.
  Header,
  // Larger, more readable Special Offer Banner typography.
  SpecialOfferBanner,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
